import React from "react";
import { useErrorHandling } from "../../hooks/useErrorHandling";
import { useLabels } from "../../hooks/useLabels";
import { useProductErrorsAndWarnings } from "../../hooks/useProductErrorsAndWarnings";
import { showProductWarningsDialogAsync } from "../dialogs/product-warnings-dialog";
import { FloatingMenuItem } from "./floating-menu-item";
import { labels } from "./labels";

export function ValidationsMenuItem() {
	const { createErrorHandler } = useErrorHandling();
	const [[productWarnings], areLabelsLoading] = useLabels([labels.productWarnings]);

	const { hasProductErrorsOrWarnings, productErrorsAndWarnings } = useProductErrorsAndWarnings();

	function onProductWarningsClicked() {
		if (productErrorsAndWarnings?.length) {
			return showProductWarningsDialogAsync(productErrorsAndWarnings).catch(
				createErrorHandler(),
			);
		}
		return Promise.resolve(true);
	}

	if (areLabelsLoading || !hasProductErrorsOrWarnings) return null;

	return (
		<FloatingMenuItem
			text={
				productWarnings
					? eXpress.utils.formatString(
							productWarnings,
							productErrorsAndWarnings.length.toString(),
					  )
					: ""
			}
			iconName="low-res"
			onClick={() => {
				// eslint-disable-next-line @typescript-eslint/no-floating-promises
				onProductWarningsClicked();
			}}
			badgeType={productErrorsAndWarnings.some((err) => err.isError) ? "error" : "warning"}
		/>
	);
}
